exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_container__2TMMJ{display:flex;align-items:center;height:100vh;justify-content:center;flex-direction:column}", ""]);

// exports
exports.locals = {
	"container": "style_container__2TMMJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/CenteredLayout/style.less
// module id = 2029
// module chunks = 8